module.exports = __webpack_public_path__ + "img/3-preview.d66bf1b9.jpg";